/**
 * Companies API Client — multi-brand aware
 */

import { apiClient } from './client'

export interface Company {
  id: string
  name: string
  description: string | null
  logoUrl: string | null
  parentCompanyId: string | null
  status: string
  settings: Record<string, unknown>
  // Billing / address
  email: string | null
  phone: string | null
  streetAddress: string | null
  unitApt: string | null
  city: string | null
  province: string | null
  postalCode: string | null
  country: string | null
  latitude: string | null
  longitude: string | null
  hstNumber: string | null
  // Square integration
  squareAccessToken: string | null
  sharePercent: string | null
  createdAt: string
  updatedAt: string
}

export interface CompanyStats {
  total: number
  active: number
  inactive: number
}

export interface CreateCompanyInput {
  name: string
  description?: string | null
  logo_url?: string | null
  parent_company_id?: string | null
  status?: string
  settings?: Record<string, unknown>
  email?: string | null
  phone?: string | null
  street_address?: string | null
  unit_apt?: string | null
  city?: string | null
  province?: string | null
  postal_code?: string | null
  country?: string | null
  latitude?: string | null
  longitude?: string | null
  hst_number?: string | null
  square_access_token?: string | null
  share_percent?: string | null
}

export interface UpdateCompanyInput {
  name?: string
  description?: string | null
  logo_url?: string | null
  parent_company_id?: string | null
  status?: string
  settings?: Record<string, unknown>
  email?: string | null
  phone?: string | null
  street_address?: string | null
  unit_apt?: string | null
  city?: string | null
  province?: string | null
  postal_code?: string | null
  country?: string | null
  latitude?: string | null
  longitude?: string | null
  hst_number?: string | null
  square_access_token?: string | null
  share_percent?: string | null
}

export interface CompaniesListResponse {
  data: Company[]
  pagination: {
    page: number
    perPage: number
    total: number
    totalPages: number
  }
}

export const companiesAPI = {
  list: (params?: { page?: number; perPage?: number; search?: string; status?: string }) =>
    apiClient.get<CompaniesListResponse>('/companies', params),

  get: (id: string) =>
    apiClient.get<Company>(`/companies/${id}`),

  stats: () =>
    apiClient.get<CompanyStats>('/companies/stats'),

  create: (data: CreateCompanyInput) =>
    apiClient.post<Company>('/companies', data),

  update: (id: string, data: UpdateCompanyInput) =>
    apiClient.put<Company>(`/companies/${id}`, data),

  deactivate: (id: string) =>
    apiClient.delete<Company>(`/companies/${id}`),
}
